<template>
  <div
    class="input-text-create"
    :class="$attrs.class"
    :style="($attrs.style as string)"
  >
    <input-text
      ref="input"
      :value="workingValue"
      :placeholder="placeholder || `+ ${$t('labels.new')}`"
      :prevent-submit="true"
      v-bind="inputAttrs"
      @update:value="workingValue = $event"
      @enter="onEnter"
    >
      <template v-if="workingValue.length > 0" #buttons>
        <button
          type="button"
          class="button-icon input__icon"
          @click="onEnter()"
        >
          <lucide-icon name="plus" />
        </button>
      </template>
    </input-text>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, useAttrs } from "vue";
import InputText from "@core/input/InputText.vue";
import LucideIcon from "@core/ui/LucideIcon.vue";

defineOptions({
  // we do not inherit all attributes directly,
  // but instead only assign class & style to the
  // main container and move all others to the input.
  inheritAttrs: false
});

const { placeholder = "" } = defineProps<{
  /**
   * Placeholder will be shown if input is empty
   */
  placeholder?: string;
}>();

const emit = defineEmits<{
  (event: "submit", value: string): void;
}>();

const workingValue = ref("");

const attrs = useAttrs();

/**
 * Attributes for the input element:
 * All attrs of the component except for class & style
 */
const inputAttrs = computed(() => {
  const attrsCopy = { ...attrs };
  delete attrsCopy.class;
  delete attrsCopy.style;
  return attrsCopy;
});

function onEnter() {
  if (workingValue.value.length > 0) {
    emit("submit", workingValue.value);
    workingValue.value = "";
  }
}
</script>

<style lang="scss">
.input-text-create {
  position: relative;
}
</style>
